@if (customerId === booking.customerId) {
  <h3 translate="bookings.viewMyBooking"></h3>
} @else {
  <h3 translate="bookings.viewExistingBooking"></h3>
}

<div class="row">
  <legend>
    <!-- Booking on same day -->
    @if (booking.startDate === booking.endDate) {
      <small class="font-weight-bold"
               [translateParams]="{
                            date: booking.startDate | date : DateUtils.dateFormat,
                            startTime: DateUtils.formatTime(booking.localStartTime),
                            endTime: DateUtils.formatTime(booking.localEndTime)
                       }"
        translate="bookings.selectedSlot.date">
      </small>
    } @else {
      <!-- Recurring Booking or Booking on several days -->
      <small class="font-weight-bold"
               [translateParams]="{
                            startDate: booking.startDate | date : DateUtils.dateFormat,
                            endDate: booking.endDate | date : DateUtils.dateFormat,
                            startTime: DateUtils.formatTime(booking.localStartTime),
                            endTime: DateUtils.formatTime(booking.localEndTime)
                       }"
        translate="{{ booking.recurring ? 'bookings.recurrentlyPlanned' : 'bookings.plannedForRange' }}">
      </small>
    }
  </legend>
</div>


<!-- Selected item display -->
<div class="row mt-4">
  <div class="col-12">
    <h4>{{ booking.itemToBook['name' + crtLang.toUpperCase()] }}</h4>

    @if (booking.itemToBook['description' + crtLang.toUpperCase()]) {
      <div class="text-pre-wrap">
        {{ booking.itemToBook['description' + crtLang.toUpperCase()] }}
      </div>
    }
  </div>
</div>

<app-customer-visitor-summary [isExploitant]="isExploitant"
                              [visitor]="booking.visitorContact"></app-customer-visitor-summary>

@if (isExploitant && bookingServiceConfig.displayCustomerCards && booking.customerId) {
  <app-customer-cards-summary
      [serviceId]="serviceId"
      [customerId]="booking.customerId"></app-customer-cards-summary>
}

@if (isExploitant && bookingServiceConfig.displayCustomerBoats && booking.customerId) {
  <app-customer-boats-summary
      [serviceId]="serviceId"
      [customerId]="booking.customerId"></app-customer-boats-summary>
}

<!-- Answers -->
@if (questions.length > 0) {
  <div class="row mt-4">
    <fieldset class="col-12 questions">
      <legend>{{ 'bookings.questions' | translate }}</legend>
      @for (question of questions; track question) {
        <div class="row">
          <p class="mb-0"><strong>{{ question['question' + crtLang.toUpperCase()] }}</strong></p>
          @if (question.answerType === ItemToBookAnswerType.Boolean) {
            <p translate="{{ answers.get(question.id) ? 'common.yes' : 'common.no' }}"></p>
          } @else {
            <p>{{ answers.get(question.id) }}</p>
          }
        </div>
      }
    </fieldset>
  </div>
}
